import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchLogisticTasksList = (params) => {
  return apiActionCreator({
    'endpoint': `/logistic/tasks${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_LOGISTIC_TASKS,
      ActionTypes.FETCHED_LOGISTIC_TASKS,
      [
        ActionTypes.FETCHED_LOGISTIC_TASKS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const updateLogisticTask = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/logistic/tasks',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_LOGISTIC_TASKS,
      [
        (response) => {
          dispatch(fetchLogisticTasksList());
          dispatch(buildSuccessMessage(response, 'Tareas actualizadas con éxito.'));
          return {
            'type': ActionTypes.UPDATED_LOGISTIC_TASKS,
            'payload': data,
          };
        },
      ],
      [
        ActionTypes.UPDATED_LOGISTIC_TASKS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  }));
};

export const createLogisticTask = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/logistic/tasks',
    'authenticated': true,
    'types': [
      ActionTypes.CREATING_LOGISTIC_TASKS,
      [
        (response) => {
          dispatch(fetchLogisticTasksList());
          dispatch(buildSuccessMessage(response, 'Tarea creada exitosamente.'));
          return {
            'type': ActionTypes.CREATED_LOGISTIC_TASKS,
            'payload': data,
          };
        },
      ],
      [
        ActionTypes.CREATED_LOGISTIC_TASKS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'data': data,
    'contentType': 'application/json',
  }));
};
